import React from 'react';
import { CategoryBorderCard } from '../../containers/CategoryBorderCard';
import classNames from 'classnames';
import classes from './BasePostCard.module.scss';
import { ButtonMenu } from '../../actions/ButtonMenu';
import { PostCardViewProps } from './BasePostCard.view';
import { PostCardMedia } from '../PostCardMedia';
import { SquareButtonIconsEnum } from '../../../constants/square-button-icons';
import { extractDomain } from '../../../helpers/extractDomainFromUrl';
import { PostScheduleHelpers } from '../../../modules/Publish/PostSchedule/postScheduleHelpers';
import { getCardText } from '../helpers/getCardText';
import { PostCardStatusTable } from '../PostCardStatusTable';
import { Debugger } from '../../containers/Debugger';
import { PostCardLinkPreview } from '../PostCardLinkPreview';
import { PostCardLinkPreviewSizeEnum } from '../PostCardLinkPreview/PostCardLinkPreview.view';
import { PostStatus, PostTiming } from '../../../models/graphql';
import { PostScheduleViewContext } from '../../../modules/Publish/PostSchedule/PostSchedule.controller';
import { PostCardStatusIcon } from '../PostCardStatusIcon';

export const BasePostCardCalendarView = (props: PostCardViewProps): JSX.Element => {
  const cardClasses = classNames(classes.BasePostCard, classes[`BasePostCard${props.orientation}`]);
  const cardBodyClasses = classNames('cell auto', classes.Wrapper);
  const cardTextClasses = classNames(
    'margin-bottom-small-8',
    classes.PostText,
    classes.PostTextCalendar,
    classes.CardText,
    classes.CardTextCalendar
  );
  const linkButtonClasses = classNames(classes.LinkButton);
  const { post } = props;

  const stackedCardsClasses = classNames(classes.StackedCardsContainerCalendar);

  const postCardMediaValues = post.variationMeta?.currentVariation.media[0]
    ? PostScheduleHelpers.mapCorePostToPostCardType(post, true)
    : undefined;

  const isStacked = post.variationMeta?.hasMultiple || false;

  const hasStatusIcon =
    post.timing !== PostTiming.QUEUE &&
    post.status !== PostStatus.PUBLISHED &&
    (post.status === PostStatus.ACTIVE || post.status === PostStatus.FAILED) &&
    (props.context === PostScheduleViewContext.LIST || props.context === PostScheduleViewContext.WEEK);

  return (
    <>
      <CategoryBorderCard borderColor={post.category.color} borderPosition={'Top'} applyCardBorder={true}>
        <Debugger tooltipContent={`Post ID: ${props.post.id}`} modalContent={props.post} />
        <div className={cardClasses}>
          <div className={cardBodyClasses}>
            <div className={'grid-x align-middle margin-top-small-8 margin-bottom-small-4'}>
              {hasStatusIcon ? (
                <div className={'cell shrink'}>
                  <PostCardStatusIcon post={post} />
                </div>
              ) : undefined}
              <div className={classNames('cell', 'auto', hasStatusIcon ? classes.TitleWidth : classes.TitleMaxWidth)}>
                <div className={classNames('one-liner', classes.CategoryName)}>{post.category.name}</div>
              </div>
            </div>
            <div className={cardTextClasses} dangerouslySetInnerHTML={{ __html: getCardText(post) }} />
            {postCardMediaValues ? (
              <>
                <div className={classes.MediaContainer}>
                  <PostCardMedia {...postCardMediaValues} orientation={props.orientation} />
                </div>
                {post.link && post.link.url && (
                  <div className={linkButtonClasses}>
                    <a href={post.link.url} target={'_blank'} rel={'noreferrer'}>
                      {extractDomain(post.link.url)}
                    </a>
                  </div>
                )}
              </>
            ) : (
              post.link && (
                <div className={classes.MediaContainer}>
                  <PostCardLinkPreview
                    linkUrl={post.link.url}
                    size={PostCardLinkPreviewSizeEnum.small}
                    thumbnailUrl={post.link.openGraph?.image || undefined}
                    title={post.link.openGraph?.title || undefined}
                  />
                </div>
              )
            )}
            <PostCardStatusTable post={props.post} orientation={props.orientation} context={props.context} />
          </div>
        </div>
        <div className={classNames(classes.DotMenu, classes.DotMenuCalendar)}>
          <ButtonMenu
            isSquareButton={true}
            buttonType={'transparent'}
            listItems={props.menuListItems}
            side={'right'}
            icon={SquareButtonIconsEnum.dotsShifted}
          />
        </div>
      </CategoryBorderCard>
      {isStacked && (
        <div className={classes.StackedCardsGrouping}>
          <div className={stackedCardsClasses}></div>
          <div className={stackedCardsClasses}></div>
        </div>
      )}
    </>
  );
};
